import React from "react";
import {
  FormControl,
  Select,
  InputBase,
  MenuItem,
  Box,
} from "@material-ui/core";
import SearchBarWithFilters from "components/search_with_filters";

const TableFilters = (props) => {
  const {
    searchText,
    handleSearchTextChange,
    filtersList = [],
    handleFilterChange,
    filterValues,
    disableSearch,
  } = props;

  return (
    <SearchBarWithFilters
      noSearch={disableSearch}
      handleSearch={handleSearchTextChange}
      searchText={searchText}
      padding={"4px 16px"}>
      <Box display={"flex"} style={{ gap: "0.8rem" }} alignItems={"center"}>
        {filtersList?.map((filter) => {
          return (
            <FormControl key={filter.name} size="medium" className={"filter"}>
              <Select
                fullWidth
                displayEmpty
                onChange={handleFilterChange.bind(null, filter.name)}
                name="status"
                value={filterValues[filter.name] ?? ""}
                input={<InputBase />}>
                {filter?.options?.map((filterOption) => {
                  return (
                    <MenuItem value={filterOption.id}>
                      {filterOption.value}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          );
        })}
      </Box>
    </SearchBarWithFilters>
  );
};

export default TableFilters;
